// extracted by mini-css-extract-plugin
module.exports = {"root":"Copyable_root__RTKRV","text":"Copyable_text__OPqgb","iconContainer":"Copyable_iconContainer__XTLUQ","icon":"Copyable_icon__7J6QN"};